import { useContext } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import { CountryContext } from 'CountryContext';
import { AppLinkInput } from 'components/AppLinkInput';
import { JoinWaitlist } from 'components/JoinTheClub/JoinWaitlist';
import { IMAGES } from 'common/images';
import { SOCIAL_LINKS } from 'navigation/constants';
import { COUNTRIES } from 'common/constants';
import 'components/JoinTheClub/index.scss';

export const JoinTheClub = ({ type }) => {
  const { country } = useContext(CountryContext);

  if (country !== COUNTRIES.INDIA) {
    return <JoinWaitlist type={type} />;
  }

  return (
    <Row className="join-club">
      <Col>
        <Row className="justify-content-center">
          <p className="join-club__title">Join the club now!</p>
        </Row>
        <Row className="justify-content-center join-club__input">
          <AppLinkInput type={type} />
        </Row>
        <Row className="justify-content-center">
          <p className="join-club__follow-text">Follow us on:</p>
        </Row>
        <Row className="justify-content-center">
          <a target="_blank" rel="noopener" href={SOCIAL_LINKS.INSTAGRAM}>
            <Image className="mr-4 join-club__social" alt="instagram" src={IMAGES.Instagram} />
          </a>
          <a target="_blank" rel="noopener" href={SOCIAL_LINKS.TWITTER}>
            <Image className="mr-4 join-club__social" alt="twitter" src={IMAGES.Twitter} />
          </a>
          <a target="_blank" rel="noopener" href={SOCIAL_LINKS.DISCORD}>
            <Image className="mr-4 join-club__social" alt="discord" src={IMAGES.Discord} />
          </a>
          <a target="_blank" rel="noopener" href={SOCIAL_LINKS.YOUTUBE}>
            <Image className="mr-4 join-club__social" alt="youtube" src={IMAGES.Youtube} />
          </a>
          <a target="_blank" rel="noopener" href={SOCIAL_LINKS.FACEBOOK}>
            <Image className="join-club__social" alt="facebook" src={IMAGES.Facebook} />
          </a>
        </Row>
      </Col>
    </Row>
  );
};
